// extracted by mini-css-extract-plugin
export default {"input":"tboxKN","notFirst":"ClcuKn","first":"ZsD7OI"};